import client from 'axiosConfig'

export interface FaqItem {
  id: number
  question: string
  answer: string
  displayOrder: number
}

const FaqServices = {
  getFaqs() {
    return client.get<{ data: FaqItem[]; status: string; httpCode: number }>(
      '/faqs/'
    )
  },
}

export default FaqServices
